import React from 'react';
import PopoverHeader from './PopoverHeader';
import { warnOnce } from './utils';
export default function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return React.createElement(PopoverHeader, props);
}


//////////////////
// WEBPACK FOOTER
// ../reactstrap/es/PopoverTitle.js
// module id = 1449
// module chunks = 25